import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class HelpSelect extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    value: PropTypes.any,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    notMultiple: PropTypes.bool,
    label: PropTypes.string,
    video: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      options: [],
      error: null,
      loading: false,
    }
  }

  componentDidMount() {
    const { user, video, disabled } = this.props

    this.setState({ loading: true })

    /* istanbul ignore else */
    if (user) {
      return new Api(user.dsToken)
        .get(
          `${API_URL.FETCH_HELP_FUNC}?video=${
            video && !disabled ? 'true' : 'false'
          }`
        )
        .then((response) => this.onFetchSuccess(response.data))
        .catch((error) => this.onFetchError(error))
    }
  }

  onFetchSuccess(data) {
    const options = data.map((e) => ({ value: e.key, label: e.value }))

    this.setState({ options, loading: false, error: null })
  }

  onFetchError(error) {
    this.setState({ error, loading: false, options: [] })
  }

  render() {
    const {
      id,
      name,
      value,
      onChange,
      translate,
      disabled = false,
      label,
    } = this.props
    const { options, loading } = this.state

    let placeholder = loading
      ? translate('option.loading')
      : translate('hint.help.config.dsFunc')
    placeholder = label ? translate(label) : placeholder

    return (
      <div>
        <Select
          className={'react-select react-select-multi'}
          classNamePrefix={'react-select'}
          id={id}
          name={name}
          value={options.filter(
            (option) =>
              option.value === (value instanceof Object ? value.value : value)
          )}
          onChange={(event) => onChange(event)}
          placeholder={placeholder}
          options={options}
          noOptionsMessage={() => translate('select.noOptionsMessage')}
          isDisabled={disabled}
        />
      </div>
    )
  }
}

export default HelpSelect
